import blossomGold from "./packs/blossom-gold";
import naturalEvening from "./packs/natural-evening";
import formalDay from "./packs/formal-day";
import colorStories from "./packs/color-stories";
import seasons from "./packs/seasons";
import editorial from "./packs/editorial";

const themes = [
    blossomGold,
    ...naturalEvening,
    ...formalDay,
    ...colorStories,
    ...seasons,
    ...editorial,
];

export const themeList = themes;

export const registry = Object.fromEntries(themes.map((theme) => [theme.id, theme]));

export function getTheme(id) {
    const key = typeof id === "string" ? id.trim() : "";
    return registry[key] || registry["blossom-gold"];
}
